'use client';

import type {ReactNode} from 'react';

interface Props {
  title: string;
  description: string;
  primaryAction: ReactNode;
  secondaryAction?: ReactNode;
}

export function PaywallModalContent({title, description, primaryAction, secondaryAction}: Props) {
  return (
    <div className='relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 text-center'>
      <div className='text-4xl mb-4'>🔒</div>
      <h2 className='text-xl font-bold text-iq-black mb-2'>{title}</h2>
      <p className='text-sm text-iq-grey-medium mb-6'>{description}</p>
      <div className='flex flex-col gap-3'>
        {primaryAction}
        {secondaryAction}
      </div>
    </div>
  );
}
